import React, { useState, useReducer } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import LoadingSpinner from '../../../components/LoadingSpinner';

// Form reducer
import formReducer from '../../../functions/formReducer';
import formValidator from '../../../functions/formValidator';


const initialState = {
    name: {
        value: '',
        min: 3,
        max: 14,
        hasError: false,
        errorMessage: ''
    },
    lastname: {
        value: '',
        min: 3,
        max: 14,
        hasError: false,
        errorMessage: ''
    },
    phonenumber: {
        value: '',
        min: 10,
        max: 12,
        hasError: false,
        errorMessage: ''
    },
    username: {
        value: '',
        min: 5,
        max: 20,
        hasError: false,
        errorMessage: ''
    },
    password: {
        value: '',
        min: 8,
        max: 25,
        hasError: false,
        errorMessage: ''
    },
    role: {
        value: 'user',
        max: 20,
        hasError: false,
        errorMessage: ''
    }
}

// const reducer = (state, action) => {
//     switch (action.type) {
//         case 'UPDATE':
//             return {
//                 ...state,
//                 [action.param]: {
//                     ...state[action.param],
//                     value: action.value,
//                     hasError: false,
//                     errorMessage: ''
//                 }
//             };
//         case 'ADD_ERROR':
//             return {
//                 ...state,
//                 [action.param]: {
//                     ...state[action.param],
//                     hasError: true,
//                     errorMessage: action.message
//                 }
//             };
//         case 'CLEAR':
//             return initialState;
//         default:
//             return state;
//     }
// }

const AddModal = (props) => {
    const [state, dispatch] = useReducer(formReducer, initialState);
    const [loading, setLoading] = useState(false);

    // const formValidator = (state, dispatch) => {
    //     let hasError = false;
    //     for (let param in state) {
    //         if (state[param].min || state[param].max) {
    //             // Min Error
    //             if (state[param].min) {
    //                 if (state[param].value.length < state[param].min) {
    //                     hasError = true;
    //                     dispatch({ type: 'ADD_ERROR', param: param, message: `${param} needs to be at least ${state[param].min} characters` });
    //                 }
    //             }

    //             // Max Error
    //             if (state[param].max) {
    //                 if (state[param].value.length > state[param].max) {
    //                     hasError = true;
    //                     dispatch({ type: 'ADD_ERROR', param: param, message: `${param} needs to be less than ${state[param].max} characters` });
    //                 }
    //             }
    //         }
    //     }

    //     return hasError;
    // };

    const onSubmit = async (e) => {
        e.preventDefault();
        const hasError = formValidator(state, dispatch);
        if (!hasError) {
            setLoading(true); // Start Loading Spinner
            const url = process.env.REACT_APP_API_URL;
            const authToken = sessionStorage.getItem('auth-token');

            const userData = {
                name: state.name.value,
                lastname: state.lastname.value,
                username: state.username.value,
                password: state.password.value,
                phonenumber: state.phonenumber.value,
                rights: state.role.value
            };

            const request = await fetch(`${url}/users`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`
                    },
                    body: JSON.stringify(userData)
                });

            if (request.status === 201) {

                // Hide the modal
                props.setShow(false);

                // This will reload the users
                props.loadUsersHandler();
                
            }

            setLoading(false); // Stop Loading Spinner
        }
    };

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)} onShow={() => dispatch({type: 'CLEAR', default: initialState })}>
            <Form onSubmit={onSubmit}>
                <Modal.Header>
                    <Modal.Title>Nuevo Usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form.Group>
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control type="text" value={state.name.value} onChange={(e) => dispatch({ type: 'UPDATE', param: 'name', value: e.target.value })} isInvalid={state.name.hasError} />
                        <Form.Control.Feedback type="invalid">{state.name.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Apellido</Form.Label>
                        <Form.Control type="text" value={state.lastname.value} onChange={(e) => dispatch({ type: 'UPDATE', param: 'lastname', value: e.target.value })} isInvalid={state.lastname.hasError} />
                        <Form.Control.Feedback type="invalid">{state.lastname.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Numero de Telefono</Form.Label>
                        <Form.Control type="text" value={state.phonenumber.value} onChange={(e) => dispatch({ type: 'UPDATE', param: 'phonenumber', value: e.target.value })} isInvalid={state.phonenumber.hasError} />
                        <Form.Control.Feedback type="invalid">{state.phonenumber.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Usuario</Form.Label>
                        <Form.Control type="text" value={state.username.value} onChange={(e) => dispatch({ type: 'UPDATE', param: 'username', value: e.target.value })} isInvalid={state.username.hasError} />
                        <Form.Control.Feedback type="invalid">{state.username.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control type="password"  value={state.password.value} onChange={(e) => dispatch({ type: 'UPDATE', param: 'password', value: e.target.value })} isInvalid={state.password.hasError} />
                        <Form.Text className="text-muted" hidden={state.password.hasError}>
                            La contraseña debe ser mas de 8 letras
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">{state.password.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Tipo de Usuario</Form.Label>
                        <Form.Control as="select" value={state.role.value} onChange={(e) => dispatch({ type: 'UPDATE', param: 'role', value: e.target.value })} custom>
                            <option value="user">Regular</option>
                            <option value="power_user">Super Usuario</option>
                            <option value="repair">Tecnico</option>
                            <option value="admin">Administrador</option>
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => props.setShow(false)}>Close</Button>
                    <Button type="submit" variant="primary" disabled={loading}>
                        <span>Crear Usuario</span>
                        {loading && <LoadingSpinner size="sm" inButton />}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default AddModal;